module.exports = __webpack_public_path__ + "img/bl-bottom.3144f5f0.png";